// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getAutomaticallyLimitnumberAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`automatically_limitnumber`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getAutomaticallyLimitnumberById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`automatically_limitnumber/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getAutomaticallyLimitnumberLotteryTypeById = async ({ token, params } : any) => {
   // console.log(params)
   try {
      return await client
         .get(`automatically_limitnumber_lottery_type/${params?.lottery_type_id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};



export const postCreateAutomaticallyLimitnumber = async ({ token, params } : any) => {
   try {
      return await client
         .post(`automatically_limitnumber`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateAutomaticallyLimitnumber = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`automatically_limitnumber/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteAutomaticallyLimitnumber = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`automatically_limitnumber/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const postCreateAutomaticallyLimitnumberDetail = async ({ token, params } : any) => {
   try {
      return await client
         .post(`automatically_limitnumber_detail`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const deleteAutomaticallyLimitnumberDetail = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`automatically_limitnumber_detail/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};
